import React, {useContext, useEffect} from 'react';
import {BookType, House, Info, LogOut, MessageCircleQuestion, Newspaper, OctagonX, Menu, ArrowUp} from 'lucide-react';
import * as Collapsible from '@radix-ui/react-collapsible';
import plPL from 'antd/lib/locale/pl_PL';
import enUS from 'antd/lib/locale/en_US';
import {clearResultsContext} from '../../../utils/clear-results-context';
import {Locale} from 'antd/es/locale';
import {useNavigate} from 'react-router-dom';
import {ResultsModel} from '../../../model/results.model';
import ResultsContext from '../../../store/results-context';
import './menubar.css';

type MenuBarProps = {
    t: (key: string) => string;
    changeLanguage: (language: string) => void;
    changeCurrentLocale: (locale: Locale) => void;
}

const MenuBar: React.FC<MenuBarProps> = ({t, changeLanguage, changeCurrentLocale}: MenuBarProps) => {

    const resultsCtx: ResultsModel = useContext(ResultsContext);
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    const navigateHome: () => void = () => navigate('/');
    const navigateAbout: () => void = () => navigate('/about');
    const navigateBrochures: () => void = () => navigate('/brochures');
    const navigateFaq: () => void = () => navigate('/faq');
    const navigateNews: () => void = () => navigate('/news');

    const logoutHandler: () => void = (): void => {
        resultsCtx.changeLicenseNumber('');
        resultsCtx.changeAgreeToTerms(false);
        localStorage.setItem('licenseIsValid', 'false');
        localStorage.setItem('loginButtonClicked', 'false');
        localStorage.setItem('agreeToTerms', 'false');
        navigate('/');
    }

    useEffect((): void => {}, [
        resultsCtx
    ]);

    return (
        <div className="top-bar__wrapper">

            <div className="menu_big-screen__wrapper">

                <div className="menu-home__wrapper" onClick={navigateHome}>
                    <House color="var(--orange)" size={24} strokeWidth={1.4}/>
                </div>

                <div className="menu-text__wrapper">
                    <div className="menu-item__wrapper" onClick={navigateAbout}>
                        <Info color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_project')}
                    </div>
                    {/*|*/}
                    {/*<div className="menu-item__wrapper">*/}
                    {/*    <CalendarDays color="var(--orange)" size={20} strokeWidth={1.4} /> {t('menu_calendar')}*/}
                    {/*</div>*/}
                    |
                    <div className="menu-item__wrapper" onClick={navigateBrochures}>
                        <BookType color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_brochures')}
                    </div>
                    |
                    <div className="menu-item__wrapper" onClick={navigateFaq}>
                        <MessageCircleQuestion color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_faq')}
                    </div>
                    |
                    <div className="menu-item__wrapper" onClick={navigateNews}>
                        <Newspaper color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_news')}
                    </div>
                </div>
                <div className="language-bar__wrapper">

                    <img className="flag__image"
                         alt="język polski"
                         onClick={() => {
                             changeLanguage('pl');
                             changeCurrentLocale(plPL);
                         }}
                         src={require('../../../assets/graphics/flagPL.png')}/>

                    <img className="flag__image"
                         alt="english version"
                         onClick={() => {
                             changeLanguage('en');
                             changeCurrentLocale(enUS);
                         }}
                         src={require('../../../assets/graphics/flagEN.png')}/>
                </div>

                <div className="menu-clear__wrapper" onClick={() => clearResultsContext(resultsCtx, navigate)}>
                    <OctagonX color="var(--orange)" size={24} strokeWidth={1.4}/>
                    {t('menu_clear_form')}
                </div>

                <div className="logout__wrapper" onClick={logoutHandler}>
                    <LogOut color="var(--orange)" size={20} strokeWidth={1.4}/>
                    {t('logout_text')}
                </div>
            </div>


            <div className="menu_small-screen__wrapper">

                <Collapsible.Root
                    open={open}
                    onOpenChange={setOpen}
                >

                    <div className="menu_small-screen_top">
                        <div className="menu_small-screen_left">
                            <div className="menu_small-home__wrapper" onClick={navigateHome}>
                                <House color="var(--orange)" size={24} strokeWidth={1.4}/>
                            </div>
                        </div>

                        <div className="menu_small-screen_middle"></div>

                        <div className="menu_small-screen_right">
                            <Collapsible.Trigger asChild>
                                {
                                    open ?
                                        <ArrowUp color="var(--orange)" size={24} strokeWidth={1.4}/> :
                                        <Menu color="var(--orange)" size={24} strokeWidth={1.4}/>
                                }
                            </Collapsible.Trigger>
                        </div>
                    </div>

                    <Collapsible.Content>
                        <div className="menu_small-screen_bottom">
                            <div className="menu-item__wrapper" onClick={navigateAbout}>
                                <Info color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_project')}
                            </div>
                            <div className="menu-item__wrapper" onClick={navigateBrochures}>
                                <BookType color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_brochures')}
                            </div>
                            <div className="menu-item__wrapper" onClick={navigateFaq}>
                                <MessageCircleQuestion color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_faq')}
                            </div>
                            <div className="menu-item__wrapper" onClick={navigateNews}>
                                <Newspaper color="var(--orange)" size={20} strokeWidth={1.4}/> {t('menu_news')}
                            </div>

                            <div className="menu_small-screen__language_wrapper">
                                <img className="flag__image"
                                     alt="język polski"
                                     onClick={() => {
                                         changeLanguage('pl');
                                         changeCurrentLocale(plPL);
                                     }}
                                     src={require('../../../assets/graphics/flagPL.png')}/>

                                <img className="flag__image"
                                     alt="english version"
                                     onClick={() => {
                                         changeLanguage('en');
                                         changeCurrentLocale(enUS);
                                     }}
                                     src={require('../../../assets/graphics/flagEN.png')}/>
                            </div>

                            <div className="menu_small-screen__logout_wrapper">
                                <div className="menu_small-screen__logout_inner_wrapper">
                                    <div className="menu_small_clear-form__wrapper" onClick={() => clearResultsContext(resultsCtx, navigate)}>
                                        <OctagonX color="var(--orange)" size={24} strokeWidth={1.4}/>
                                        {t('menu_clear_form')}
                                    </div>

                                    <div className="menu_small_logout__wrapper" onClick={logoutHandler}>
                                        <LogOut color="var(--orange)" size={20} strokeWidth={1.4}/>
                                        {t('logout_text')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapsible.Content>

                </Collapsible.Root>
            </div>

        </div>
    );
}
export default MenuBar;
